<template>
  <v-speed-dial
    v-model="fab"
    :top="top"
    :bottom="bottom"
    :right="right"
    :left="left"
    :direction="textDisposeDirection"
    :open-on-hover="hover"
    :transition="transition"
  >
    <template v-slot:activator>
      <v-btn-toggle v-model="fab" fab class="fab">
        <v-icon v-if="fab"> mdi-close </v-icon>
        <v-icon color="#3A63DE" v-else> fa-info-circle </v-icon>
      </v-btn-toggle>
    </template>
    <v-card class="d-flex pa-0 ma-0 card" tile color="#CEDAFB">
      <v-card-text class="text-card">
        <span>
          {{ this.message }}
        </span>
      </v-card-text>
    </v-card>
  </v-speed-dial>
</template>

<script>
export default {
  name: "QuotationFloatActionButton",
  data: () => ({
    fab: true,
    fling: true,
    transition: "slide-x-reverse-transition"
  }),
  props: {
    textDisposeDirection: {
      type: String,
      default: "left"
    },
    top: {
      type: Boolean,
      default: true
    },
    bottom: {
      type: Boolean,
      default: false
    },
    right: {
      type: Boolean,
      default: true
    },
    left: {
      type: Boolean,
      default: false
    },
    hover: {
      type: Boolean,
      default: false
    },
    message: {
      type: String
    }
  },
  watch: {
    top(val) {
      this.bottom = !val;
    },
    right(val) {
      this.left = !val;
    },
    bottom(val) {
      this.top = !val;
    },
    left(val) {
      this.right = !val;
    }
  }
};
</script>
<style lang="sass" scoped>
.card
  min-width: 330px
  max-height: 180px
.text-card
  overflow-y: auto
.v-btn-toggle.fab
  background: transparent
  border: none
</style>
